/**
 * @description 视频组件
 */

import {defineComponent} from 'san';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import Image from '@baidu/cosmic/image';
import {BROWSER_MESSAGES} from '../../../../common/const/index';
import styles from './index.module.less';
import {VideoPlyrProps} from './interface';

const VideoPlyr = defineComponent< VideoPlyrProps>({
    template: /* html */ `
        <div class="${styles['video-wrapper']}">
            <template s-if="!_isLowerVersion && videoUrl">
                <video
                    s-if="_isPlyrSupported"
                    id="_player"
                    playsinline
                    controls
                    data-poster="{{poster}}"
                    class="plyr__video-embed"
                >
                    <source src="{{videoUrl}}" type="video/mp4" />
                </video>
                <video s-else id="native-video" class="${styles['native-video']}" controls poster="{{poster}}">
                    <source src="{{videoUrl}}" type="video/mp4">
                </video>
            </template>
            <template s-else>
                <cos-image
                    src="{{poster}}"
                    class="cos-image-16-9 cos-image-fit-cover"
                />
            </template>
        </div>
    `,
    components: {
        'cos-image': Image,
    },
    initData() {
        return {
            poster: '',
            videoUrl: '',
            _player: null,
            _isPlyrSupported: true,
            // TODO: 针对无法播放、有bug等ua进行判断
            _isLowerVersion: false,
        };
    },

    inited() {
        // 检测是否支持 Plyr 的 HTML5 视频，返回api、ui支持情况
        this.data.set('_isPlyrSupported', Plyr.supported('video', 'html5')?.api);
    },

    attached() {
        this.handleCompat();
    },

    // 浏览器播放支持性兼容处理
    handleCompat() {
        if (this.data.get('_isLowerVersion')) {
            console.warn(BROWSER_MESSAGES.VERSION_LOW);
            return;
        }

        if (!this.data.get('_isPlyrSupported')) {
            console.warn(BROWSER_MESSAGES.PLYR_UNSUPPORTED);
            return;
        }

        this.handlePlyrInit();
    },

    // 播放初始化
    handlePlyrInit() {
        const _player = new Plyr('#_player', {
            controls: [
                'play-large',
            ],
        });
        this.data.set('_player', _player);
        this.handleEvents(this.data.get('_player'));
    },

    // 监听
    handleEvents(_player: Plyr) {
        if (!_player) {
            return;
        }
        _player.on('play', () => {
            this.fire('play');
        });
        _player.on('pause', () => {
            this.fire('pause');
        });
        _player.on('ended', () => {
            this.fire('ended');
        });
        _player.on('enterfullscreen', () => {
            this.fire('enterfullscreen');
        });
    },

    // 销毁
    detached() {
        if (this.data.get('_player')) {
            this.data.get('_player').destroy();
        }
    },
});

export default VideoPlyr;
